export default __webpack_public_path__ + "static/media/41k.650814d7.md";